<template>
  <el-dialog
    title="修改密码"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    :append-to-body="true"
    @close="handleClose"
  >
    <el-form
      ref="passwordForm"
      :model="formData"
      :rules="rules"
      label-width="100px"
      v-loading="loading"
    >
      <el-alert
        title="密码要求"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 20px"
      >
        <ul style="margin: 5px 0; padding-left: 20px; line-height: 1.8">
          <li>长度至少 6 个字符</li>
          <li>建议包含大小写字母、数字和特殊字符</li>
        </ul>
      </el-alert>

      <el-form-item label="当前密码" prop="oldPassword">
        <el-input
          v-model="formData.oldPassword"
          type="password"
          placeholder="请输入当前密码"
          show-password
          autocomplete="off"
        >
          <i slot="prefix" class="el-input__icon el-icon-lock"></i>
        </el-input>
      </el-form-item>

      <el-form-item label="新密码" prop="newPassword">
        <el-input
          v-model="formData.newPassword"
          type="password"
          placeholder="请输入新密码"
          show-password
          autocomplete="off"
        >
          <i slot="prefix" class="el-input__icon el-icon-key"></i>
        </el-input>
      </el-form-item>

      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input
          v-model="formData.confirmPassword"
          type="password"
          placeholder="请再次输入新密码"
          show-password
          autocomplete="off"
        >
          <i slot="prefix" class="el-input__icon el-icon-key"></i>
        </el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import UserAPI from '@/api/user';

export default {
  name: 'ChangePasswordDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // 验证确认密码
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.formData.newPassword) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };

    return {
      dialogVisible: false,
      loading: false,
      formData: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' },
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少 6 个字符', trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.resetForm();
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val);
    },
  },
  methods: {
    /**
     * 提交修改密码
     */
    async handleSubmit() {
      // 表单验证
      try {
        await this.$refs.passwordForm.validate();
      } catch (error) {
        return;
      }

      this.loading = true;
      try {
        const response = await UserAPI.resetPassword({
          oldPassword: this.formData.oldPassword,
          newPassword: this.formData.newPassword,
          confirmPassword: this.formData.confirmPassword,
        });

        if (response.success) {
          this.$message.success('密码修改成功，请重新登录');
          this.handleClose();
          
          // 延迟跳转到登录页
          setTimeout(() => {
            this.$store.dispatch('user/logout');
            this.$router.push('/login');
          }, 1500);
        } else {
          this.$message.error(response.message || '密码修改失败');
        }
      } catch (error) {
        console.error('修改密码失败:', error);
        this.$message.error('修改密码失败: ' + error.message);
      } finally {
        this.loading = false;
      }
    },

    /**
     * 关闭对话框
     */
    handleClose() {
      this.resetForm();
      this.dialogVisible = false;
    },

    /**
     * 重置表单
     */
    resetForm() {
      this.formData = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      };
      this.$nextTick(() => {
        this.$refs.passwordForm?.clearValidate();
      });
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

::v-deep .el-alert {
  background-color: #ecf5ff;
  border-color: #d9ecff;
}

::v-deep .el-alert__title {
  font-size: 14px;
  font-weight: 500;
}

::v-deep .el-form-item__label {
  font-weight: 500;
}
</style>
